(function () {
  function ready(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") setTimeout(fn, 0);
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function uniqSorted(arr) {
    return Array.from(new Set(arr.filter(Boolean))).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base" })
    );
  }

  function haversineKm(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function safeJsonParse(el, fallback) {
    try {
      const txt = el?.textContent?.trim();
      if (!txt) return fallback;
      return JSON.parse(txt);
    } catch (e) {
      return fallback;
    }
  }

  function escapeHtml(str) {
    return String(str ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function buildDirectionsUrl(store) {
    if (store.googleMapsUrl) return store.googleMapsUrl;
    const q = encodeURIComponent(`${store.lat},${store.lng}`);
    return `https://www.google.com/maps/search/?api=1&query=${q}`;
  }

  function initOne(config) {
    const { sectionId } = config;

    const elData = document.getElementById(`zl-data-${sectionId}`);
    const storesRaw = safeJsonParse(elData, []);
    const stores = Array.isArray(storesRaw) ? storesRaw : [];

    const elSearch = document.getElementById(`zl-search-${sectionId}`);
    const elNearMe = document.getElementById(`zl-nearme-${sectionId}`);
    const elReset = document.getElementById(`zl-reset-${sectionId}`);
    const elCity = document.getElementById(`zl-city-${sectionId}`);
    const elType = document.getElementById(`zl-type-${sectionId}`);
    const elResults = document.getElementById(`zl-results-${sectionId}`);
    const elCount = document.getElementById(`zl-count-${sectionId}`);
    const elStatus = document.getElementById(`zl-status-${sectionId}`);

    const elSwiper = document.getElementById(`zl-swiper-${sectionId}`);
    const elPrev = document.getElementById(`zl-prev-${sectionId}`);
    const elNext = document.getElementById(`zl-next-${sectionId}`);

    const mapEl = document.getElementById(`zl-map-${sectionId}`);
    if (!mapEl) return;

    const normalized = stores
      .map((s) => ({
        id: s.id || `${(s.name || "store")}-${Math.random().toString(16).slice(2)}`,
        name: s.name || "",
        address: s.address || "",
        city: s.city || "",
        type: s.type || "",
        phone: s.phone || "",
        hours: s.hours || "",
        googleMapsUrl: s.googleMapsUrl || "",
        lat: Number(s.lat),
        lng: Number(s.lng),
      }))
      .filter((s) => Number.isFinite(s.lat) && Number.isFinite(s.lng) && s.name);

    // Filters
    uniqSorted(normalized.map((s) => s.city)).forEach((c) => {
      const opt = document.createElement("option");
      opt.value = c;
      opt.textContent = c;
      elCity.appendChild(opt);
    });

    uniqSorted(normalized.map((s) => s.type)).forEach((t) => {
      const opt = document.createElement("option");
      opt.value = t;
      opt.textContent = t;
      elType.appendChild(opt);
    });

    // Map
    const map = L.map(mapEl, { scrollWheelZoom: false }).setView(
      [config.mapDefaultLat, config.mapDefaultLng],
      config.mapDefaultZoom
    );

    L.tileLayer(config.tileUrl, {
      attribution: config.tileAttribution,
      maxZoom: 19,
    }).addTo(map);

    const markerLayer = L.layerGroup().addTo(map);

    // ===============================
    // CUSTOM PIN (IMAGE URL BASED)
    // ===============================
    // Replace these URLs with your custom pin URLs:
    const PIN_DEFAULT_URL = "https://cdn.shopify.com/s/files/1/0635/3462/9079/files/Nabila---Location-Logo.png?v=1772523017";
    const PIN_ACTIVE_URL  = "https://cdn.shopify.com/s/files/1/0635/3462/9079/files/Nabila---Location-Logo.png?v=1772523017"; // optional (can be same as default)

    // Display size in px (adjust as needed)
    const PIN_W = 50;
    const PIN_H = 50;

    const defaultIcon = L.icon({
      iconUrl: PIN_DEFAULT_URL,
      iconSize: [PIN_W, PIN_H],
      iconAnchor: [PIN_W / 2, PIN_H],     // bottom-center tip
      popupAnchor: [0, -PIN_H + 10]
    });

    const activeIcon = L.icon({
      iconUrl: PIN_ACTIVE_URL || PIN_DEFAULT_URL,
      iconSize: [PIN_W, PIN_H],
      iconAnchor: [PIN_W / 2, PIN_H],
      popupAnchor: [0, -PIN_H + 10]
    });

    // Keep marker refs by store id for fast icon switching
    const markersById = new Map();

    function setActiveMarkerIcon(storeId) {
      markersById.forEach((m, id) => {
        m.setIcon(id === storeId ? activeIcon : defaultIcon);
      });
    }

    // Fuse
    const fuse = new Fuse(normalized, {
      keys: [
        { name: "name", weight: 0.45 },
        { name: "city", weight: 0.25 },
        { name: "address", weight: 0.25 },
        { name: "type", weight: 0.05 },
      ],
      threshold: 0.35,
      ignoreLocation: true,
    });

    let swiperInstance = null;
    let userLoc = null;         // {lat,lng}
    let activeId = null;
    let userMarker = null;

    function setStatus(msg) {
      elStatus.textContent = msg || "";
    }

    function getFiltered() {
      const q = (elSearch.value || "").trim();
      const city = elCity.value || "";
      const type = elType.value || "";

      let list = normalized;

      if (q) list = fuse.search(q).map((r) => r.item);
      if (city) list = list.filter((s) => s.city === city);
      if (type) list = list.filter((s) => s.type === type);

      if (userLoc) {
        list = list
          .map((s) => ({ ...s, distanceKm: haversineKm(userLoc.lat, userLoc.lng, s.lat, s.lng) }))
          .sort((a, b) => (a.distanceKm ?? 1e9) - (b.distanceKm ?? 1e9));
      } else {
        list = list.map((s) => ({ ...s, distanceKm: null }));
      }

      return list;
    }

    function renderMarkers(list) {
      markerLayer.clearLayers();
      markersById.clear();

      list.forEach((s) => {
        const m = L.marker([s.lat, s.lng], { title: s.name, icon: defaultIcon });
        m._zlId = s.id;

        m.on("click", () => {
          activateStore(s.id, { slideTo: true, centerMap: true });
        });

        m.addTo(markerLayer);
        markersById.set(s.id, m);
      });

      // keep active icon on re-render
      if (activeId) setActiveMarkerIcon(activeId);

      // Do NOT auto-fit bounds if a location is selected (keeps centering logic stable)
      if (!activeId && list.length) {
        const bounds = L.latLngBounds(list.map((s) => [s.lat, s.lng]));
        map.fitBounds(bounds, { padding: [30, 30] });
      }
    }

    function initOrUpdateSwiper() {
      if (!window.Swiper || !elSwiper) return;

      if (!swiperInstance) {
        swiperInstance = new Swiper(elSwiper, {
          direction: "vertical",
          slidesPerView: 4,          // desktop default
          spaceBetween: 0,
          mousewheel: true,
          watchSlidesProgress: true,
          breakpoints: {
            0:   { slidesPerView: 3, spaceBetween: 8 }, // mobile
            641: { slidesPerView: 4, spaceBetween: 0 }  // tablet/desktop
          }
        });

        if (elPrev) elPrev.addEventListener("click", () => swiperInstance.slidePrev());
        if (elNext) elNext.addEventListener("click", () => swiperInstance.slideNext());
      } else {
        swiperInstance.update();
      }
    }

    function renderResults(list) {
      elCount.textContent = `${list.length} location${list.length === 1 ? "" : "s"}`;

      if (!list.length) {
        elResults.innerHTML = `
          <div class="swiper-slide">
            <div class="zl-empty">No locations found. Try adjusting your search or filters.</div>
          </div>`;
        initOrUpdateSwiper();
        return;
      }

      elResults.innerHTML = list.map((s) => {
        const isActive = s.id === activeId ? "is-active" : "";
        const dist = userLoc && Number.isFinite(s.distanceKm) ? `• ${s.distanceKm.toFixed(1)} km` : "";

        const phone = s.phone ? `<a class="zl-link" href="tel:${escapeHtml(s.phone)}">Call</a>` : "";
        const hours = s.hours ? `<span>${escapeHtml(s.hours)}</span>` : "";
        const directionsUrl = buildDirectionsUrl(s);

        return `
          <div class="swiper-slide">
            <div class="zl-card ${isActive}" data-id="${escapeHtml(s.id)}" role="button" tabindex="0">
              <div class="zl-card__top">
                <h3 class="zl-card__name">${escapeHtml(s.name)}</h3>
                ${s.type ? `<span class="zl-pill">${escapeHtml(s.type)}</span>` : ""}
              </div>
              <div class="zl-card__addr">${escapeHtml(s.address)}${s.city ? `, ${escapeHtml(s.city)}` : ""}</div>
              <div class="zl-card__meta">
                ${hours}
                ${dist ? `<span>${dist}</span>` : ""}
              </div>
              <div class="zl-card__actions">
                <a class="zl-link" href="${escapeHtml(directionsUrl)}" target="_blank" rel="noopener noreferrer">
                  ${escapeHtml(config.openDirectionsLabel || "Directions")}
                </a>
                ${phone}
              </div>
            </div>
          </div>
        `;
      }).join("");

      elResults.querySelectorAll(".zl-card").forEach((card) => {
        const id = card.getAttribute("data-id");
        card.addEventListener("click", () => activateStore(id, { slideTo: true, centerMap: true }));
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            activateStore(id, { slideTo: true, centerMap: true });
          }
        });
      });

      initOrUpdateSwiper();
    }

    function highlightCard(id) {
      elResults.querySelectorAll(".zl-card").forEach((c) => {
        c.classList.toggle("is-active", c.getAttribute("data-id") === id);
      });
    }

    function openMarkerPopup(id) {
      const store = normalized.find((x) => x.id === id);
      if (!store) return;

      const marker = markersById.get(id);
      if (!marker) return;

      const popupHtml = `
        <div style="font-family:inherit">
          <div style="font-weight:600; margin-bottom:4px">${escapeHtml(store.name)}</div>
          <div style="font-size:12px; opacity:.85; margin-bottom:6px">
            ${escapeHtml(store.address)}${store.city ? `, ${escapeHtml(store.city)}` : ""}
          </div>
          <a href="${escapeHtml(buildDirectionsUrl(store))}" target="_blank" rel="noopener noreferrer">
            ${escapeHtml(config.openDirectionsLabel || "Directions")}
          </a>
        </div>`;
      marker.bindPopup(popupHtml).openPopup();
    }

    function centerMapOnStore(store) {
      const zoom = Math.max(map.getZoom(), config.mapActiveZoom || 15);
      map.setView([store.lat, store.lng], zoom, { animate: true });
    }

    function activateStore(id, opts = {}) {
      const store = normalized.find((x) => x.id === id);
      if (!store) return;

      activeId = id;

      // UI highlight
      highlightCard(id);

      // Toggle marker icon state
      setActiveMarkerIcon(id);

      // Center map on marker (true center)
      if (opts.centerMap) {
        centerMapOnStore(store);
      }

      // Popup
      openMarkerPopup(id);

      // Slide list to selected
      if (opts.slideTo && swiperInstance) {
        const cards = Array.from(elResults.querySelectorAll(".zl-card"));
        const idx = cards.findIndex((c) => c.getAttribute("data-id") === id);
        if (idx >= 0) swiperInstance.slideTo(idx);
      }
    }

    function refresh() {
      const list = getFiltered();
      renderResults(list);
      renderMarkers(list);

      // Auto-select first item on initial load
      if (list.length && (!activeId || !list.some((s) => s.id === activeId))) {
        activeId = null;
        activateStore(list[0].id, { slideTo: false, centerMap: false });
      }
    }

    // Search debounce
    let t = null;
    elSearch.addEventListener("input", () => {
      clearTimeout(t);
      t = setTimeout(() => {
        activeId = null;
        refresh();
      }, 80);
    });

    elCity.addEventListener("change", () => { activeId = null; refresh(); });
    elType.addEventListener("change", () => { activeId = null; refresh(); });

    elReset.addEventListener("click", () => {
      elSearch.value = "";
      elCity.value = "";
      elType.value = "";
      userLoc = null;
      activeId = null;
      setStatus("");

      if (userMarker) { map.removeLayer(userMarker); userMarker = null; }

      map.setView([config.mapDefaultLat, config.mapDefaultLng], config.mapDefaultZoom);
      refresh();
    });

    elNearMe.addEventListener("click", () => {
      if (!navigator.geolocation) {
        setStatus("Geolocation is not supported in this browser.");
        return;
      }

      setStatus("Detecting your location…");

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          userLoc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          setStatus("Showing nearest locations.");

          if (userMarker) map.removeLayer(userMarker);
          userMarker = L.circleMarker([userLoc.lat, userLoc.lng], { radius: 6, weight: 2 }).addTo(map);
          userMarker.bindPopup("You are here").openPopup();

          map.setView([userLoc.lat, userLoc.lng], 13, { animate: true });

          activeId = null;
          refresh();
        },
        () => setStatus("Unable to access your location. Please allow permissions and try again."),
        { enableHighAccuracy: true, timeout: 9000, maximumAge: 60000 }
      );
    });

    // initial
    refresh();
  }

  ready(function () {
    const maxWaitMs = 6000;
    const start = Date.now();

    function boot() {
      if (typeof window.L === "undefined" || typeof window.Fuse === "undefined" || typeof window.Swiper === "undefined") {
        if (Date.now() - start > maxWaitMs) return;
        return setTimeout(boot, 60);
      }

      const queue = window.ZL_LOCATOR_QUEUE || [];
      queue.forEach(initOne);
      window.ZL_LOCATOR_QUEUE = [];
    }

    boot();
  });
})();